import styled from 'styled-components'
import { DesktopFilters, Filter } from '../style'

export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space.xs};
  align-items: center;
  justify-content: center;
`

export const ModalFilterWrapper = styled(DesktopFilters)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: ${({ theme }) => theme.space.xs};

  .ant-select {
    width: 100%;
  }

  ${Filter} {
    width: 100%;
  }
`
